export default {"src":"/_next/static/media/upper-wave.46530bc5.svg","height":117,"width":1440,"blurWidth":0,"blurHeight":0};